export default __webpack_public_path__ + "img/5ac252f35c3858593f8cfb7dde63c845.svg";